
import Kyc from '../../components/Kyc'
import DriverLayout from '../../layouts/DriverLayout'

const KycDetail = () => {

    return (
        <DriverLayout>
            <Kyc />
        </DriverLayout>
    )
}

export default KycDetail
